// The client's boss registry: one line per boss (its module's factory). Mirrors sim/bosses/index.ts.
// A view is built the first time an island announces its boss (RunSnap.bossKind), so a boss's
// model loads during that island's breather, never at startup.

import { BossKind } from '../../../../sim/bosses/types';
import type { BossClientFactory } from './types';
import { cerberusClient } from './cerberus';
import { bulwarkClient } from './bulwark';
import { anglerClient } from './angler';
import { courtClient } from './court';
import { leviathanClient } from './leviathan';

export const BOSS_CLIENTS: Partial<Record<BossKind, BossClientFactory>> = {
  [BossKind.Cerberus]: cerberusClient,
  [BossKind.BulwarkCube]: bulwarkClient,
  [BossKind.Angler]: anglerClient,
  [BossKind.BlackCourt]: courtClient,
  [BossKind.Leviathan]: leviathanClient,
};
